// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { UserProfileSubjectRoleManagementDtoBreederRoleManagement, UserProfileSubjectRoleManagementDtoBreederRoleManagementSchema } from 'api/gen/UserProfileSubjectRoleManagementDtoBreederRoleManagement';

const requiredPart = t.interface({
  content: t.union([t.array(UserProfileSubjectRoleManagementDtoBreederRoleManagementSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelUserProfileSubjectRoleManagementDtoBreederRoleManagementSchema = excess(requiredPart);

export interface PagedModelUserProfileSubjectRoleManagementDtoBreederRoleManagement extends t.TypeOf<typeof PagedModelUserProfileSubjectRoleManagementDtoBreederRoleManagementSchema> {}
